import { render, screen } from "@testing-library/react";
import { ThemeProvider } from "styled-components";
import { terriaTheme } from "../../lib/ReactViews/StandardUserInterface";
import WarningBox from "../../lib/ReactViews/Preview/WarningBox";
import { jsx as _jsx } from "react/jsx-runtime";
describe("WarningBox", function () {
  beforeEach(function () {
    // terria = new Terria({ baseUrl: "./" });
  });
  it("renders", function () {
    render(/*#__PURE__*/_jsx(ThemeProvider, {
      theme: terriaTheme,
      children: /*#__PURE__*/_jsx(WarningBox, {
        children: "Test text"
      })
    }));
    expect(screen.getByText("Test text")).toBeTruthy();
  });
});